
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { BlogPost } from "@/hooks/useBlogPosts";

interface BlogPostCardProps {
  post: BlogPost;
  index: number;
}

export const BlogPostCard = ({ post, index }: BlogPostCardProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const postUrl = post.slug ? `/blog/${post.slug}` : `/blog/${post.id}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Card className="h-full overflow-hidden hover:shadow-md transition-shadow duration-300">
        <div className="relative aspect-[16/9] overflow-hidden bg-slate-100">
          {post.image_url ? (
            <img
              src={post.image_url}
              alt={post.title}
              className="object-cover h-full w-full"
            />
          ) : (
            <div className="flex items-center justify-center h-full bg-slate-200">
              <span className="text-slate-400">No image</span>
            </div>
          )}
        </div>
        <CardHeader className="pb-2">
          <span className="text-sm text-slate-500">{formatDate(post.created_at)}</span>
          <h3 className="text-xl font-bold text-slate-900 line-clamp-2">
            {post.title}
          </h3>
        </CardHeader>
        <CardContent>
          <p className="text-slate-600 line-clamp-3">
            {post.excerpt || "No excerpt available for this post."}
          </p>
        </CardContent>
        <CardFooter>
          <Link 
            to={postUrl}
            className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
          >
            Read more <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </CardFooter>
      </Card>
    </motion.div>
  );
};
